export default {
  snackMessage: state => state.snackMessage,
  filters: state => state.filters,
  initCount: state => state.initCount,
  headerHeight: state => state.headerHeight,
  filterIsFilled: (state) => (filterName) => {
    if (!Object.prototype.hasOwnProperty.call(state.filters, filterName)) {
      return false
    }
    const validTypes = ['boolean', 'string', 'number']

    if (['newPatientFilter'].includes(filterName)) {
      validTypes.push('undefined')
    }

    return validTypes.includes(typeof state.filters[filterName].value)
  },
  filledSteps: (state) => state.filledSteps
}
